import { shippingApi } from './config/delfarApi';
import { GetShipmentResponseDto } from './dto/shipping.dto';

export const getShipment = async (shipmentId: string): Promise<GetShipmentResponseDto> =>
    shippingApi.get<GetShipmentResponseDto>(`${shipmentId}`).then((r) => r.data);
